import { API } from "@project/shared";

export const ScoutEntry = async ({ id, data }) => {
  return API.put(`/members/scouts/${id}`, data);
};
